// extracted by mini-css-extract-plugin
export default {"cls1":"FocusedNav-cls1_jY0","cls2":"FocusedNav-cls2_khp FocusedNav-cls1_jY0"};